var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('SidebarDesktop'),_c('SidebarMobile',{attrs:{"is-open":_vm.isOpen},on:{"sidebar:close":function($event){return _vm.$emit('sidebar:close')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }